let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ig02a")).then(() => parcelRequire('7Bh2L'));